/**
 * Autodesk Build module shortcuts (Home, Files, Sheets, …).
 * Opens ACC in a new tab; star bookmarks the deep link.
 */

import React from 'react';
import { bookmarkUrlKey } from '../../utils/bookmarkUrl';

const AutodeskBuildModules = ({
  modules = [],
  bookmarkedUrls = new Set(),
  onQuickBookmark,
  bookmarking = false,
  crumbs = 'Tools',
  emptyHint = 'Paste the project URL above to list tools.',
  openLabel = 'Open ↗',
}) => {
  const openExternal = (webUrl) => {
    if (webUrl) window.open(webUrl, '_blank', 'noopener,noreferrer');
  };

  if (!modules.length) {
    return (
      <div style={styles.empty}>
        {emptyHint}
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.toolbar}>
        <div style={styles.crumbs}>{crumbs}</div>
        <button
          type="button"
          onClick={() => openExternal(modules.find((m) => m.id === 'home')?.webUrl || modules[0]?.webUrl)}
          style={styles.externalBtn}
        >
          {openLabel}
        </button>
      </div>
      <ul style={styles.list}>
        {modules.map((it) => {
          const starred = bookmarkedUrls.has(bookmarkUrlKey(it.webUrl));
          return (
            <li key={it.id} style={styles.row}>
              <button
                type="button"
                onClick={() => openExternal(it.webUrl)}
                style={styles.rowMain}
                title={it.name}
              >
                <span style={styles.icon}>{it.icon || '🔗'}</span>
                <span style={styles.name}>{it.name}</span>
              </button>
              <div style={styles.rowActions}>
                <button
                  type="button"
                  style={{
                    ...styles.starBtn,
                    color: starred ? '#d97706' : '#94a3b8',
                  }}
                  title={starred ? 'Remove bookmark' : 'Bookmark this tool'}
                  disabled={bookmarking || !it.webUrl}
                  onClick={() => onQuickBookmark && onQuickBookmark(it)}
                >
                  {starred ? '★' : '☆'}
                </button>
                <button type="button" style={styles.smallBtn} onClick={() => openExternal(it.webUrl)}>
                  Open ↗
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const styles = {
  wrap: {
    border: '1px solid #e2e8f0',
    borderRadius: 8,
    background: '#fff',
    overflow: 'hidden',
    marginBottom: '1rem',
  },
  empty: {
    padding: '1rem',
    color: '#64748b',
    fontSize: '0.9rem',
    fontStyle: 'italic',
    border: '1px dashed #cbd5e1',
    borderRadius: 8,
    marginBottom: '1rem',
    background: '#f8fafc',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    padding: '10px 14px',
    borderBottom: '1px solid #e2e8f0',
    background: '#f8fafc',
    flexWrap: 'wrap',
  },
  crumbs: { fontSize: 13, fontWeight: 600, color: '#0f766e' },
  externalBtn: {
    padding: '6px 10px',
    background: '#0f766e',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    fontSize: 12,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  list: { listStyle: 'none', margin: 0, padding: '6px 0' },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '2px 10px',
    borderBottom: '1px solid #f1f5f9',
  },
  rowMain: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: 'none',
    border: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    padding: '8px 4px',
    minWidth: 0,
    fontSize: 13,
    color: '#0f172a',
  },
  icon: { width: 22, flexShrink: 0 },
  name: { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  rowActions: { display: 'flex', gap: 4, flexShrink: 0 },
  starBtn: {
    padding: '2px 8px',
    fontSize: 16,
    lineHeight: 1,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  smallBtn: {
    padding: '4px 8px',
    fontSize: 11,
    background: '#f8fafc',
    border: '1px solid #cbd5e1',
    borderRadius: 4,
    cursor: 'pointer',
    color: '#334155',
    whiteSpace: 'nowrap',
  },
};

export default AutodeskBuildModules;
